/**
 * Adzuki
 * affix.js
 */

(function Affix($, Adzuki)
{
	"use strict";

	// affixed
	$(document).on('affixed.bs.affix', function fixAffixWidth(e)
	{
		var $affixed = $(e.target),
		    $parent  = $affixed.parent();

		$affixed.width($parent.width());
	});

	// un-affixed
	$(document).on('affixed-top.bs.affix', function fixUnAffixWidth(e) {
		$(e.target).css('width', '');
	});

}(jQuery, window.Adzuki || {}));
